import React from 'react';
import classNames from 'classnames';
import { Icon } from '@shoflo-rundown/polymer.legacy';

/**
 * Responsive Item Lock
 *
 */
export default React.createClass({
  displayName: 'ResponsiveItemLock',

  propTypes: {
    isLocked: React.PropTypes.bool,
  },

  render() {
    let { isLocked } = this.props;

    let iconName = isLocked ? 'lock' : 'unlock';

    let classes = classNames('csr-lock-wrapper', {
      'csr-lock-locked': isLocked,
      'csr-lock-unlocked': !isLocked,
    });

    return (
      <div className={classes}>
        <Icon name={iconName} size={1} />
      </div>
    );
  },
});
